export const defaultPathName = '/';

export const homeAreaMenuName = 'Startside';
export const homeAreaPathName = '/';

export const embeddedPathName = 'embedded';
export const standAlonePathName = 'standalone';
